var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imagesPath)?_c('img',{attrs:{"src":_vm.imagesPath,"width":_vm.width}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }